import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  AddPage,
  ViewPage,
} from './pages';

const UsersPage = (): JSX.Element => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.users.add.root}`} component={AddPage} />
      <Route path={`${path}`} component={ViewPage} />
    </Switch>
  );
};

export default UsersPage;
